
<template>
  <div class="app-container">
    <div class="formBox"  ref="searchBox">
      <el-form  :inline="true"  :model="searchFrom" ref="searchFrom" class="demo-form-inline"  label-width="100px"  size="mini"  >
        <div class="formItemBox">
            <el-form-item label="捆包编号:" class="">
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode"></el-input>
            </el-form-item>
           <template v-for="(column,index) in searchList" >
              <el-form-item label="订单编号:" v-if="column.enName=='orderNo'&&(index<seacrchNum||topShow)" :key="column.enName" class="">
                <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.ddbh"></el-input>
              </el-form-item>
              <el-form-item label="结算客户:" v-else-if="column.enName=='payee'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.payee" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" v-else-if="column.enName=='productTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.productType" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否一票制:"  v-else-if="column.enName=='ticketSystemYn'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.ticketSystemYn" filterable placeholder="请选择" >
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="是" value="是" ></el-option>
                  <el-option  label="否" value="否" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单来源:"  v-else-if="column.enName=='orderSourceName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderSources" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="手动" value="0" ></el-option>
                  <el-option  label="转包" value="1" ></el-option>
                  <el-option  label="分段" value="3" ></el-option>
                  <el-option  label="货主端" value="8" ></el-option>
                  <el-option  label="首钢配载" value="9,11" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配载方式:"  v-else-if="column.enName=='stowageTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.stowageType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="指派" value="0" ></el-option>
                  <el-option  label="转包" value="1" ></el-option>
                  <el-option  label="分段" value="2" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务类型:"  v-else-if="column.enName=='orderBusinessTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderBusinessType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入计价:"  v-else-if="column.enName=='revenueValuationName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.revenueValuation" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in SRJJlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务部门:"  v-else-if="column.enName=='businessSubunit'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessSubunit" filterable placeholder="请选择" @change="bumenChangeCX">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务人员:"  v-else-if="column.enName=='businessUser'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessUser" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配载状态:"  v-else-if="column.enName=='orderStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderStates" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="待配载+配载中" value="0,1" ></el-option>
                  <el-option  label="待配载" value="0" ></el-option>
                  <el-option  label="配载中" value="1" ></el-option>
                  <el-option  label="已完成" value="2" ></el-option>
                  <!-- <el-option  label="已作废" value="3" ></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="超时报警:"  v-else-if="column.enName=='timeoutReminder'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.timeoutReminder" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有车调度操作超时" value="4" ></el-option>
                  7<el-option label="外部车调度操作超时" value="5" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="处理状态:"  v-else-if="column.enName=='handleStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.handleState" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="待确认" value="1" ></el-option>
                  <el-option  label="己退回" value="2" ></el-option>
                  <el-option  label="自有车承运" value="3" ></el-option>
                  <el-option  label="流转中" value="4" ></el-option>
                  <el-option  label="外部车承运" value="5" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="要求到达时间:"   v-else-if="column.enName=='arrivalTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.arrivalTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="创建时间:"   v-else-if="column.enName=='createTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
               <template v-else>
                <el-form-item :label="column.cnName+':'"  :key="column.enName" v-if="(index<seacrchNum||topShow)">
                  <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
                </el-form-item>
               </template>
           </template>
           <el-form-item label="是否有合同:" class="">
              <el-select v-model="searchFrom.agreementFlag" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="有" value="0" ></el-option>
                  <el-option  label="无" value="1" ></el-option>
                </el-select>
            </el-form-item>
        </div>
        <!-- <div v-if="isZhankai" class="inpBox box">
          <el-form-item label="订单编号:" >
            <el-input  placeholder="" v-model="searchFrom.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="始发流向:" >
            <el-input  placeholder="" v-model="searchFrom.startDirection"></el-input>
          </el-form-item>
          <el-form-item label="目的流向:" >
              <el-input  placeholder="" v-model="searchFrom.endDirection"></el-input>
          </el-form-item>
          <el-form-item label="外部单号:" >
            <el-input  placeholder="" v-model="searchFrom.externalOrderNumber"></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="box1">
            <i class="el-icon-arrow-down icon" v-if="isZhankai" @click="isZhankai=!isZhankai"></i>
            <i class="el-icon-arrow-up icon" v-if="!isZhankai"  @click="isZhankai=!isZhankai"></i>
        </div> -->
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <!-- <el-button type="primary" @click="THimportFn()">导入</el-button> -->
            <el-button type="primary" v-if="btnFlg[2]" size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[3]" size="mini" @click="addFn">新增</el-button>
             <el-button type="primary" v-if="btnFlg[26]" size="mini" @click="addHYFn">新增</el-button>
            <el-button type="primary" v-if="btnFlg[4]" size="mini" @click="chaihedanFN(1)">合单</el-button>
            <el-button type="primary" v-if="btnFlg[5]" size="mini" @click="chaihedanFN(2)">拆单</el-button>
            <el-button type="primary" v-if="btnFlg[6]" size="mini" @click="zhipaiFN">指派</el-button>
            <el-button type="primary" v-if="btnFlg[7]" size="mini" @click="zhuanbaoFN">转包</el-button>
            <el-button type="primary" v-if="btnFlg[8]" size="mini" @click="QXzhuanbaoFN">取消转包</el-button>
            <el-button type="primary" v-if="btnFlg[9]" size="mini" @click="dayinFN">打印</el-button>
            <el-button type="primary" v-if="btnFlg[10]" size="mini" @click="fenduanFN">分段</el-button>
            <el-button type="primary" v-if="btnFlg[17]" size="mini" @click="wanchengFN">完成</el-button>
             <el-button type="primary" v-if="btnFlg[20]" size="mini" @click="shengmaFN(null)">生码</el-button>
          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>

      </el-form>
    </div>
     <div class="openBox">
      <div class="openChild" v-if="topShow" @click="topFn">
        <i class="el-icon-caret-top" ></i>
      </div>
      <div class="openChild" v-if="!topShow" @click="topFn">
        <i class="el-icon-caret-bottom" ></i>
      </div>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table  :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" class="tableComent"
       height="100%" style="width:100%" center border  row-key="orderBusinessId" lazy :load="load" :key="symbolKey" :cell-style="getCellStyle"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-if="tabHeadList.length>0" :row-class-name="({row}) => selectedRows.some(r=>r.orderId==row.orderId)?'sel-row':''">
        <el-table-column type="selection" width="55" :selectable="checkSelectable" fixed></el-table-column>
        <!-- <el-table-column  type="index" width="55" label="序号"></el-table-column> -->
        <el-table-column label="序号" width="70" fixed>
          <template slot-scope="scope">
            <span v-if="scope.row.num">{{scope.row.num}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div>
             <el-button type="text" size="mini" v-if="(scope.row.orderState===0||(scope.row.orderState==2&&scope.row.stowageType==1))&&scope.row.orderSource===0
             &&scope.row.stowageType!=2&&userName==scope.row.createUser" v-show="btnFlg[11]" @click="editFN(scope.row)">修改</el-button>
              <!-- 分段修改 -->
              <el-button type="text" size="mini" v-if="(scope.row.orderState===0||scope.row.orderState==1)&&scope.row.stowageType==2&&userName==scope.row.createUser"
              v-show="btnFlg[11]" @click="editFN1(scope.row)">修改</el-button>
              <!-- 提单订单人车修改 -->
              <el-button type="text" size="mini" v-if="scope.row.orderSource==11" v-show="btnFlg[19]" @click="rencheFn(scope.row)">人车</el-button>
              <el-button type="text" size="mini" v-if="(scope.row.orderState===0||scope.row.orderState==1)&&scope.row.orderSource==11&&orgCode==scope.row.orderBusinessCreateDepartmentCode"
              v-show="btnFlg[11]" @click="editFN2(scope.row)">修改</el-button>

             <el-button type="text" size="mini" v-if="scope.row.orderState==1||scope.row.orderState==2"  v-show="btnFlg[12]" @click="wayFn(scope.row)">运单</el-button>
             <el-button type="text" size="mini" v-if="scope.row.orderState===0&&scope.row.orderSource!=2&&scope.row.orderSource!=8&&scope.row.orderSource!=3&&
             scope.row.orderSource!=10&&scope.row.stowageType!=2" v-show="btnFlg[13]" @click="zuofeiFn(scope.row)">作废</el-button>
             <el-button type="text" size="mini"  v-show="btnFlg[14]" v-if="scope.row.orderSource!=8&&scope.row.orderSource!=3&&scope.row.orderSource!=10" @click="addFn(2,scope.row)">复制</el-button>
             <el-button type="text" size="mini"  v-show="btnFlg[15]" v-if="scope.row.orderSource!=3&&scope.row.orderSource!=10" @click="fujianFn(scope.row)">附件</el-button>
             <el-button type="text" size="mini" v-if="scope.row.stowageType==2&&scope.row.orderState!=3"  v-show="btnFlg[16]" @click="qxfdFn(scope.row)">取消分段</el-button>
             <el-button type="text" size="mini" v-if="scope.row.orderSource===0&&scope.row.stowageType===0&&(scope.row.orderState==1||scope.row.orderState==2)"  @click="jiahuoFn(scope.row)">货物</el-button>
             <el-button type="text" size="mini" v-if="scope.row.orderQrCodeId&&btnFlg[21]"  @click="erweimaFn(scope.row)">二维码</el-button>
             <el-button type="text" size="mini" v-if="scope.row.handleState==1&&ziyoucheFlag&&scope.row.orderState===0&&btnFlg[22]"  @click="liuzhuanFn(scope.row)">流转</el-button>
             <el-button type="text" size="mini" v-if="((scope.row.handleState==1&&ziyoucheFlag)||(scope.row.handleState==4&&!ziyoucheFlag))&&scope.row.orderState===0&&btnFlg[23]"  @click="chengyunFn(scope.row)">承运</el-button>
             <el-button type="text" size="mini" v-if="scope.row.handleState!=2&&scope.row.orderState===0&&btnFlg[24]"  @click="tuihuiFn(scope.row)">退回</el-button>
             <el-button type="text" size="mini" v-if="btnFlg[25]"  @click="TJdetailFn(scope.row)">详情</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[27]"  @click="ziliaoguidangFn(scope.row)">资料归档</el-button>
            </div>
          </template>
        </el-table-column>
        <template v-for="column in tabHeadList">
          <template v-if="column.enName=='orderNo'">
            <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="订单编号" :key="column.enName">
              <template slot-scope="scope">
                <span class="textColer" style="cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='residualTotalWeight'">
            <el-table-column property="orderSource" label="剩余量"  width="240" :key="column.enName">
              <template scope="scope">
                <div>
                  <div class="textColer" style="cursor: pointer;" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                  <div v-else>
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='orderStateName'">
            <el-table-column property="orderSource" label="配载状态"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.orderState===0">{{scope.row.orderStateName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.orderState==1">{{scope.row.orderStateName}}</span>
                  <span  style="color: #81B337;" v-else-if="scope.row.orderState==2">{{scope.row.orderStateName}}</span>
                  <span  style="color: #9A9A9A;" v-else-if="scope.row.orderState==3">{{scope.row.orderStateName}}</span>
                  <span v-else>{{scope.row.orderStateName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='urgencyFlagName'">
            <el-table-column property="orderSource" label="提货紧急程度"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.urgencyFlag===2">{{scope.row.urgencyFlagName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.urgencyFlag==1">{{scope.row.urgencyFlagName}}</span>
                  <span  v-else>{{scope.row.urgencyFlagName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='contractReminderDate'">
            <el-table-column property="contractReminderDate" label="合同提醒日期"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.contractWarning===-1||scope.row.contractWarning=='0'">{{scope.row.contractReminderDate}}</span>
                  <span  v-else>{{scope.row.contractReminderDate}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='accountReminderDate'">
            <el-table-column property="accountReminderDate" label="账期提醒日期"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.accountWarning===-1||scope.row.accountWarning=='0'">{{scope.row.accountReminderDate}}</span>
                  <span  v-else>{{scope.row.accountReminderDate}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column  :key="column.enName" :prop="column.enName" :label="column.cnName" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <el-table-column v-for="item in column.child" :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" :formatter="formatterRowEmpty">
              </el-table-column>
            </el-table-column>
          </template>
        </template>

        <!-- <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="订单编号">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span>{{[ "待处理", "处理中", "已处理","已作废"][scope.row.orderState]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="订单来源">
          <template scope="scope">
            <div>
              <span >{{[ "手动", "转包", "货主端","分段"][scope.row.orderSource]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载方式">
          <template scope="scope">
            <div>
              <span>{{[ "指派", "转包","分段"][scope.row.stowageType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="payee" :formatter="formatterRowEmpty" width="200" label="结算客户"></el-table-column>
        <el-table-column property="productTypeName" :formatter="formatterRowEmpty" width="120" label="货物类型"></el-table-column>
        <el-table-column property="orderWeight" label="订单量" width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.orderWeight&&scope.row.orderNumber">
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}/{{scope.row.orderNumber}}件</span>
              <span v-else>
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载量"  width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.goodsYn==1">
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}/{{scope.row.stowageNumber}}件</span>
              <span v-else>
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="剩余量"  width="120">
          <template scope="scope">
            <div>
              <div style="color: #0c46a2;cursor: pointer;" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                <span>
                  {{scope.row.residualWeight}}{{scope.row.measuringUnit}}/{{scope.row.residualNumber}}件</span>
              </div>
              <div v-else>
                  <span>{{scope.row.residualWeight}}{{scope.row.measuringUnit}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="startDirection" width="180" :formatter="formatterRowEmpty" label="始发流向"></el-table-column>
        <el-table-column property="endDirection" width="180" :formatter="formatterRowEmpty" label="目的流向"></el-table-column>
        <el-table-column width="170" property="arrivalTime" :formatter="dateTimeFormat" label="要求到货时间"></el-table-column>
        <el-table-column property="requiredModel" width="100" :formatter="formatterRowEmpty" label="需求车型"></el-table-column>
        <el-table-column property="needLength" width="100" :formatter="formatterRowEmpty" label="需求车长"></el-table-column>
        <el-table-column property="receiptRequest" width="100" :formatter="formatterRowEmpty" label="回单要求"></el-table-column>
        <el-table-column property="ticketSystemYn" width="100" :formatter="formatterRowEmpty" label="是否一票制"></el-table-column>
        <el-table-column property="makeTicketYn" width="100" :formatter="formatterRowEmpty" label="是否开票"></el-table-column>
        <el-table-column property="revenueValuation" label="收入计价">
          <template scope="scope">
            <div>
              <span>{{[ "按吨", "包车","按方","按件"][scope.row.revenueValuation]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomePattern" label="收入方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.incomePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeUnitPrice" label="收入单价" width="100">
          <template scope="scope">
            <div>
              {{scope.row.incomeUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeAmount" width="120" :formatter="formatterRowEmpty" label="收入金额(元)"></el-table-column>
        <el-table-column property="payer" width="150" :formatter="formatterRowEmpty" label="转包单位"></el-table-column>
        <el-table-column property="expenditurePattern" label="支出方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.expenditurePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightPricingType" label="运费计价">
          <template scope="scope">
            <div>
              <span>{{["按吨", "包车","按方","按件"][scope.row.freightPricingType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightUnitPrice" label="运费单价" width="120">
          <template scope="scope">
            <div>
              {{scope.row.freightUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightAmount" width="120" :formatter="formatterRowEmpty" label="运费金额(元)"></el-table-column>
        <el-table-column property="serviceRate" width="100" :formatter="formatterRowEmpty" label="服务费率%"></el-table-column>
        <el-table-column property="serviceCharge" width="120" :formatter="formatterRowEmpty" label="服务费(元)"></el-table-column>
        <el-table-column property="freightTotal" width="120" :formatter="formatterRowEmpty" label="运费总额(元)"></el-table-column>
        <el-table-column property="taxRate" width="100" :formatter="formatterRowEmpty" label="税率%"></el-table-column>
        <el-table-column property="businessUnit" width="120" :formatter="formatterRowEmpty" label="业务部门"></el-table-column>
        <el-table-column property="businessUser" width="120" :formatter="formatterRowEmpty" label="业务人员"></el-table-column>
        <el-table-column property="orderBusinessType" label="业务类型">
          <template scope="scope">
            <div>
              <span >{{[ "外库业务", "本库业务"][scope.row.orderBusinessType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="externalOrderNumber" :formatter="formatterRowEmpty" width="180" label="外部单号" show-overflow-tooltip></el-table-column>
        <el-table-column property="createUser" width="150" :formatter="formatterRowEmpty" label="创建人"></el-table-column>
        <el-table-column property="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 转包 -->
    <el-dialog  title="转包" :close-on-click-modal="false" :close-on-press-escape="false"  @close="ZBflag = false"  :visible.sync="ZBflag" width="1000px" center>
      <div>
        <div class="box3">
            <p class="box31">订单号：{{rowData.orderNo}}</p>
            <p class="box31">结算客户：{{rowData.payee}}</p>
        </div>
        <div class="box3">
          <p class="box31" style="color:#67C23A">始发流向：{{rowData.startDirection}}</p>
          <p class="box31" style="color:#F56C6C">目的流向：{{rowData.endDirection}}</p>
          <p>货物：<span class="red">{{rowData.productTypeName}}/{{rowData.orderWeight}}{{rowData.measuringUnit}}</span></p>
        </div>
        <hr>
        <el-form  :inline="true"  :model="goodform" ref="goodform" :rules="rules"  class="demo-form-inline jiaoyan"  label-width="100px"  size="mini"  >
          <el-form-item label="转包类型">
            <template >
              <el-radio-group v-model="goodform.subcontractType"  @change="zbChange">
                <el-radio :label="0" >部门</el-radio>
                <!-- <el-radio :label="1">承运商</el-radio> -->
                <el-radio :label="2">分子公司</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <div v-if="goodform.subcontractType==2">
            <el-form-item label="分子公司:" prop="gsSubCompanyCode" class="width1">
              <el-select  v-model="goodform.gsSubCompanyCode" filterable placeholder="请选择" @change="fzgsChange">
                <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="部门名称:" prop="gsSubOrgCode" class="width1">
              <el-select  v-model="goodform.gsSubOrgCode" filterable placeholder="请选择" @change="FZbumenChange">
                <el-option v-for="item in FZbumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户:" prop="gsUserId" class="width1">
              <el-select  v-model="goodform.gsUserId" filterable placeholder="请选择" @change="FZyonghuChange">
                <el-option v-for="item in FZyonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款方:">
               {{goodform.gsSubCompanyName}}
            </el-form-item>
          </div>
          <div v-else>
             <!-- <el-form-item label="部门名称:" prop="limitOrgCode" class="width1">
             <el-cascader  v-model="value"   :options="zuzhiTree" @change="handleChange"></el-cascader>
              <el-select  v-model="goodform.limitOrgCode" filterable placeholder="请选择" @change="bumenChange">
                <el-option v-for="item in zuzhiTree" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="部门名称:" prop="limitSubOrgCode" class="width1">
              <el-select  v-model="goodform.limitSubOrgCode" filterable placeholder="请选择" @change="bumenChange">
                <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户:" prop="limitUserId" class="width1">
              <el-select  v-model="goodform.limitUserId" filterable placeholder="请选择" @change="yonghuChange">
                <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款方:">
              {{goodform.limitOrgName}}
            </el-form-item>
          </div>
          <div class="addressBox" style="margin-top:20px">
            <h4 class="title">
              <span>结算信息</span>
            </h4>
            <zhichu1 :goodform="goodform"  v-if="ZBflag&&goodform.subcontractType==2"></zhichu1>
            <el-table :data="[{}]"  bordersize="mini" class="tableBox" style="" max-height="500px"
             v-if="ZBflag&&goodform.subcontractType!=2"   center border >
              <el-table-column label="支出方式" min-width="100">
                <template slot="header" >
                  <div><span class="red">*</span>支出方式</div>
                </template>
                <template >
                  <div>
                    <el-form-item label=""    class="table_error"  prop="expenditurePattern">
                      <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择" @change="zcfsChange">
                        <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="运费计价" min-width="100">
                <template >
                  <div v-if="goodform.orderAce">
                    <el-form-item label=""    class="table_error" prop="freightPricingType">
                      <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                        <template  v-for="item in SRJJlist">
                            <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-else>
                    {{ goodform.freightPricingTypeName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="运费单价(元)" min-width="100">
                <template slot="header" >
                  <div><span class="red">*</span>运费单价(元)</div>
                </template>
                <template >
                  <div>
                    <el-form-item label=""   class="table_error" prop="freightUnitPrice" v-if="goodform.freightPricingType!=1" >
                      <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
                    </el-form-item>
                    <span v-else>-</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="运费金额(元)" min-width="100">
                <template slot="header" >
                  <div><span class="red">*</span>运费金额(元)</div>
                </template>
                <template >
                  <div>
                    <el-form-item label=""  class="table_error" prop="freightAmount" >
                      <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightAmount"  ></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- <zhichu :goodform="goodform"  ></zhichu> -->

          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZBflag = false">取 消</el-button>
        <el-button type="primary" @click="ZBsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 作废 -->
    <el-dialog  title="作废" :close-on-click-modal="false" :close-on-press-escape="false"  @close="ZFflag = false"  :visible.sync="ZFflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  :model="ZFform" ref="ZFform" class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="作废原因" class="item1" prop="causeCancellation">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="ZFform.causeCancellation" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZFflag = false">取 消</el-button>
        <el-button type="primary" @click="ZFsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 退回 -->
    <el-dialog  title="退回" :close-on-click-modal="false" :close-on-press-escape="false"  @close="THflag = false"  :visible.sync="THflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  :model="THform" ref="THform" class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="退回原因" class="item1" prop="handleRemark">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="THform.handleRemark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="THflag = false">取 消</el-button>
        <el-button type="primary" @click="THsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 剩余货物信息 -->
    <el-dialog  title="剩余货物信息" :close-on-click-modal="false" :close-on-press-escape="false"  @close="SYHWflag = false"  :visible.sync="SYHWflag" width="900px" center>
      <div id="printMe" class="dayinBox"  ref="printSY">
         <div class="box3">
            <p class="box31">订单号：{{rowData.orderNo}}</p>
            <p class="box31">结算客户：{{rowData.payee}}</p>
        </div>
        <div class="box3" >
          <p class="box31" style="color:#67C23A">始发流向：{{rowData.startDirection}}</p>
          <p class="box31" style="color:#F56C6C">目的流向：{{rowData.endDirection}}</p>
          <p>货物：{{rowData.productTypeName}}/
            <span v-if="rowData.residualWeight"><span class="red">{{rowData.residualWeight}}</span>吨</span>
            <span v-if="rowData.residualWeight&&(rowData.residualNumber||rowData.residualVolumn)">/</span>
            <span v-if="rowData.residualNumber"><span class="red">{{rowData.residualNumber}}</span>件</span>
            <span v-if="rowData.residualNumber&&rowData.residualVolumn">/</span>
            <span v-if="rowData.residualVolumn"><span class="red">{{rowData.residualVolumn}}</span>方</span>
          </p>
          <div style="margin-bottom:10px;" >
            <el-button type="primary" @click="SYdayinFn">打印</el-button>
            <el-button type="primary" :disabled="isDisable" @click="hwdaochuFn">导出</el-button>
          </div>
        </div>
        <table style="word-break:break-all;word-wrap:break-all;" class="sytable" v-if="SYgoodList.length>0">
        <tr>
          <td>序号</td>
          <td>捆包号</td>
          <td>重量(吨)</td>
          <td>数量(件)</td>
          <td>体积(方)</td>
          <td>品名</td>
          <td>材质</td>
          <td>规格</td>
          <td>货位</td>
          <td>合同号</td>
          <td>合约号</td>

        </tr>
        <tr v-for="(item, index) in SYgoodList" :key="index">
          <td >{{ index+1 }}</td>
          <td >{{ item.cargoBarcode ?item.cargoBarcode :'-'}}</td>
          <td >{{ item.weight?Number(item.weight).toFixed(3):'-' }}</td>
          <td >{{ item.number?item.number:'-'}}</td>
          <td >{{ item.volumn?Number(item.volumn).toFixed(3):'-' }}</td>
          <td >{{ item.productName?item.productName:'-'  }}</td>
          <td >{{ item.model?item.model:'-' }}</td>
          <td >{{ item.specification ?item.specification:'-'}}</td>
          <td >{{item.cargoLocation?item.cargoLocation:'-'}}</td>
          <td >{{ item.contractNumber?item.contractNumber:'-' }}</td>
          <td >{{item.agreementNumber?item.agreementNumber:'-'}}</td>
        </tr>
      </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SYHWflag = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 附件 -->
    <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fujianFlag" width="500px" center>
      <div class="fujianBox">
         <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
      </div>
      <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
        append-to-body width="800px" center>
        <div style="text-align: right;">
          <el-button type="primary" @click="dayinImgFn">打印</el-button>
          <div id="printMe"  ref="print">
            <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
     <!-- 人车信息 -->
    <el-dialog  title="人车" :close-on-click-modal="false" :close-on-press-escape="false"  @close="rencheFlag = false"  :visible.sync="rencheFlag" width="95%" center>
      <div id="printMe" class="dayinBox"  ref="printSY">
         <div class="box3">
            <p class="box31">订单号：{{rowData.orderNo}}</p>
            <p class="box31">外部单号：{{rowData.externalOrderNumber?rowData.externalOrderNumber:'-'}}</p>
        </div>
        <hr>
        <div style="margin-top:20px" class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>车辆信息</span>
          </h4>
        </div>
        <div>
          <el-table height="300px" size="mini" ref="tabref" :data="rencheList" style="width:100%" border center>
            <el-table-column type="index"  label="序号" width="60"></el-table-column>
            <el-table-column label="操作"  width="100">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" @click="xieyiFn(scope.row)">协议</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true"  prop="generalCarrier"
              label="承运商" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号"
              min-width="100" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverPhone" label="司机电话"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column property="collectionType" label="收款类型">
              <template scope="scope">
                <div>
                  <span >{{['企业','司机','车队长'][scope.row.collectionType-1]}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="payer" label="收款方"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="expenditurePatternName" label="支出方式"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="freightPricingTypeName" label="运费计价"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="freightUnitPrice" label="运费单价"
                min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="freightTaxTotal" label="运费金额"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="serviceRate" label="服务费率%"
              min-width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="serviceCharge" label="服务费"
              min-width="120" ></el-table-column>
               <el-table-column :show-overflow-tooltip="true" prop="freightTaxRate" label="运费税率%"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="rencheFlag = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
    <!-- 合单拆单有货 -->
    <zhipaiyouhuo v-if="ZPYHflag" :rowDataList="rowDataList"  :ZPYHflag.sync='ZPYHflag'></zhipaiyouhuo>
     <!-- 合单拆单无货 -->
    <zhipaiwuhuo v-if="ZPWHflag" :dataList="rowDataList"  :ZPWHflag.sync='ZPWHflag'></zhipaiwuhuo>
    <!-- 指派 -->
    <zhipai v-if="ZPflag" :rowDataList="rowDataList"  :ZPflag.sync='ZPflag'></zhipai>
    <!-- 分段 -->
    <fenduan v-if="fenduanFlag" :rowDataList="rowDataList"  :fenduanFlag.sync='fenduanFlag'></fenduan>
    <!-- 分段修改收发货 -->
   <xiugaiDizhi v-if="xiugaiDizhiFlag" :zidanList="zidanList"  :rowData="rowData" :xiugaiDizhiFlag.sync='xiugaiDizhiFlag'></xiugaiDizhi>
    <!-- 修改首钢 -->
   <xiugaiSG v-if="xiugaiSGFlag"  :rowData="rowData" :xiugaiSGFlag.sync='xiugaiSGFlag'></xiugaiSG>
   <!-- 首钢人车协议 -->
   <xieyiSG v-if="xieyiSGFlag"  :rowData="rowData" :xieyiSGFlag.sync='xieyiSGFlag'></xieyiSG>
   <!-- 加货 -->
   <jiahuo v-if="jiahuoFlag"  :rowData="rowData" :jiahuoFlag.sync='jiahuoFlag'></jiahuo>
   <!-- 生码 -->
   <shengma v-if="shengmaFlag"  :rowData="rowData" :shengmaFlag.sync='shengmaFlag'></shengma>
   <!-- 二维码 -->
   <erweima v-if="erweimaFlag"  :rowData="rowData" :erweimaFlag.sync='erweimaFlag'></erweima>
    <!-- 资料归档 -->
   <ziliaoguidang v-if="ziliaoFlag"  :rowData="rowData" :ziliaoFlag.sync='ziliaoFlag'></ziliaoguidang>
    <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>

<script>
import { getBtn, getAttributeB } from '@/utils/getButton'
import { getDictionaryDetailList, findCustomerInfoList, findOrderList, cancellationOrder, subcontract, cancelSubcontract, getOrderAttachments,
  findAssignmentGoods, findSonSectionList, cancelSectionOpenOrde, checkUpdateOrder, queryMyPageField, completeOrder, getOrderBill, transferOrder,
  carryOrder, returnOrder } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getCurrUserDepartment, getDepartmentUsers, getCurrUserCompany } from '@/api/newCrm'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/components/import.vue'
import zhipaiyouhuo from '@/views/newTMS/publicFiles/orderManage/zhipaiyouhuo.vue'
import zhipaiwuhuo from '@/views/newTMS/publicFiles/orderManage/zhipaiwuhuo.vue'
import zhipai from '@/views/newTMS/publicFiles/orderManage/zhipai.vue'
import zhichu from '@/views/newTMS/publicFiles/wayAndOrder/zhichu.vue'
import zhichu1 from '@/views/newTMS/publicFiles/wayAndOrder/zhichu1.vue'
import fenduan from '@/views/newTMS/publicFiles/orderManage/fenduan.vue'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
import xiugaiDizhi from '@/views/newTMS/publicFiles/orderManage/xiugaiDizhi.vue'
import xiugaiSG from '@/views/newTMS/publicFiles/orderManage/xiugaiSG.vue'
import xieyiSG from '@/views/newTMS/publicFiles/orderManage/xieyiSG.vue'
import jiahuo from '@/views/newTMS/publicFiles/orderManage/jiahuo.vue'
import shengma from '@/views/newTMS/publicFiles/orderManage/shengma.vue'
import erweima from '@/views/newTMS/publicFiles/orderManage/erweima.vue'
import ziliaoguidang from '@/views/newTMS/publicFiles/orderManage/ziliaoguidang.vue'
export default {
  components: {
    importC, zhipaiyouhuo, zhipaiwuhuo, zhipai, zhichu, zhichu1, fenduan, tableHeads, exportSetting, xiugaiDizhi, xiugaiSG, xieyiSG, jiahuo, shengma, erweima, ziliaoguidang
  },
  data () {
    return {
      groupCode: 'platformOrder',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderStates: '0,1'
      },
      tableList: [],
      total: 0,
      loading: false,
      rules: {
        subcontractType: [
          { required: true, message: '请选择转包类型', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        generalCarrier: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ],
        limitUserId: [
          { required: true, message: '请选择人员', trigger: 'blur' }
        ],
        limitOrgCode: [
          { required: true, message: '请选择业务部门', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        freightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        handleRemark: [
          { required: true, message: '请输入退回原因', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01N0010100', '01N0010200', '01N0010300', '01N0010400', '01N0010500', '01N0010600', '01N0010700', '01N0010800', '01N0010900',
        '01N0010A00', '01N0010B00', '01N0010C00', '01N0010D00', '01N0010E00', '01N0010F00', '01N0010G00',
        '01N0010H00', '01N0010I00', '01N0010J00', '01N0010K00', '01N0010M00', '01N0010N00', '01N0010O00', '01N0010P00', '01N0010Q00', '01N0010R00', '01N0010S00', '01N0010T00'],
      kehuList: [],
      isDisable: false,
      customTypes: [],
      importDialog: false,
      ZPYHflag: false,
      ZPWHflag: false,
      ZPflag: false,
      ZBflag: false, // 转包
      fenduanFlag: false, // 分段
      fuwufeiFLag: '',
      CYSList: [], // 承运商
      goodform: {},
      SYgoodList: [], // 剩余货物信息
      SYHWflag: false,
      isZhankai: false,
      HWlist: [],
      YWLXlist: [],
      SRJJlist: [],
      bumenList: [],
      yonghuList: [],
      ZFflag: false, // 作废
      ZFform: {},
      rowDataList: [],
      fujianFlag: false,
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      rowData: {},
      symbolKey: '',
      zidanList: [],
      xiugaiDizhiFlag: false,
      userName: localStorage.getItem('userName'),
      orgCode: localStorage.getItem('orgCode'),
      rencheFlag: false,
      rencheList: [],
      xiugaiSGFlag: false,
      xieyiSGFlag: false,
      jiahuoFlag: false,
      shengmaFlag: false,
      erweimaFlag: false,
      ZHFSlist: [], // 支出方式list  转包用
      zigsList: [], // 分子公司列表
      FZbumenList: [], // 分子部门列表
      FZyonghuList: [], // 分子用户列表
      topShow: false,
      searchList: [],
      seacrchNum: window.innerWidth > 1680 ? 9 : 7,
      ziyoucheFlag: true,
      THflag: false, // 退回
      THform: {},
      ziliaoFlag: false,
      selectedRows: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/qiYunOrder')
    // this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.queryMyPageField()
    // 获取是否自有车调度属性
    getAttributeB('ARRownedCarFlag', 1).then(res => {
      this.ziyoucheFlag = res[0] != 1
    })
  },

  mounted () {

  },
  methods: {
    // 资料归档
    ziliaoguidangFn (row) {
      this.rowData = row
      this.ziliaoFlag = true
    },
    // 报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '超时报警') {
        if (row.timeoutReminder == '自有车调度操作超时') {
          return { color: '#FEB0A4' }
        } else if (row.timeoutReminder == '外部车调度操作超时') {
          return { color: '#FDCC0F' }
        } else {
          return { }
        }
      }
    },
    // 流转
    liuzhuanFn (row) {
      this.$confirm('是否执行流转操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        transferOrder({
          orderBusinessId: row.orderBusinessId
        }).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 承运
    chengyunFn (row) {
      this.$confirm('是否执行承运操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        carryOrder({
          orderBusinessId: row.orderBusinessId,
          handleState: this.ziyoucheFlag ? 3 : 5
        }).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 退回
    tuihuiFn (row) {
      this.THform = {}
      this.THform.orderBusinessId = row.orderBusinessId
      this.THflag = true
    },
    THsaveFn () {
      this.$refs.THform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })

          returnOrder(this.THform).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.THflag = false
            loading.close()
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 170) + 'px'
      })
    },
    topFn () {
      this.topShow = !this.topShow
      this.getHeight()
      this.seacrchNum = window.innerWidth > 1680 ? 9 : 7
    },
    // erweima
    erweimaFn (row) {
      this.rowData = row
      this.erweimaFlag = true
    },
    // 生码
    shengmaFN (row) {
      if (row) {
        this.rowData = row
        this.shengmaFlag = true
      } else {
        let selectData = this.$refs.table.selection
        this.rowData = selectData[0]
        if (selectData.length != 1) {
          this.$alert('请选择一条要操作的数据', '系统提示')
          return
        }
        if (!(selectData[0].orderSource === 0 || selectData[0].orderSource == 8 || selectData[0].orderSource == 1)) {
          this.$alert('订单来源为手动、货主端、转包的订单才能生成二维码', '系统提示')
          return
        }
        if (selectData[0].goodsYn == 1) {
          this.$alert('只有无货的订单才能生成二维码', '系统提示')
          return
        }
        if (selectData[0].stowageType) {
          this.$alert('配载方式为转包、分段不能生成二维码', '系统提示')
          return
        }
        if (selectData[0].orderState == 2 || selectData[0].orderState == 3) {
          this.$alert('已处理或者已作废的订单不能生成二维码', '系统提示')
          return
        }
        this.shengmaFlag = true
      }
    },
    // 加货
    jiahuoFn (row) {
      this.rowData = row
      this.rowData.goodsList = []
      this.jiahuoFlag = true
    },
    // 协议
    xieyiFn (row) {
      for (var key in row) {
        this.rowData[key] = row[key]
      }
      this.xieyiSGFlag = true
    },
    rencheFn (row) {
      this.rowData = row
      getOrderBill({ orderId: row.orderId }).then(res => {
        this.rencheList = res.carrierList
        this.rencheFlag = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    checkSelectable (row) {
      if (row.orderState == 3) {
        return false
      } else {
        return true
      }
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      this.tabHeadList = []
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.searchList = this.tabHeadList.filter(item => item.isSettingQuery == 1)
        this.getHeight()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 完成
    wanchengFN () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].orderState > 1) {
        this.$alert('该状态的订单不能执行完成操作！', '系统提示')
        return
      }
      if (selectData[0].stowageType == 2) {
        this.$alert('已分段的订单不能完成!', '系统提示')
        return
      }
      this.$confirm('是否执行完成操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        completeOrder({
          orderBusinessId: selectData[0].orderBusinessId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 附件
    fujianFn (row) {
      getOrderAttachments({ orderId: row.orderId }).then(res => {
        if (res.length == 0) {
          this.$alert('此订单没有附件', '系统提示')
        } else {
          this.fujianFlag = true
          this.fujianList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.fujianList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    dayinImgFn () {
      this.$print(this.$refs.print)
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 作废
    zuofeiFn (row) {
      this.ZFflag = true
      this.ZFform = {}
      this.ZFform.orderBusinessId = row.orderBusinessId
    },
    ZFsaveFn () {
      this.$refs.ZFform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cancellationOrder(this.ZFform).then(res => {
            loading.close()
            this.ZFflag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 货物剩余量
    WHSYLFn (row) {
      this.SYHWflag = true
      this.rowData = row
      findAssignmentGoods({ orderId: row.orderId }).then(res => {
        this.SYgoodList = res
      })
    },
    // 剩余货物打印
    SYdayinFn () {
      this.$print(this.$refs.printSY)
    },
    // 导出
    hwdaochuFn () {
      exportExcel(
        this.global.tmsPlus + '/order/exportOrderGoods',
        { orderId: this.rowData.orderId },
        '货物列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 分段
    fenduanFN () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if ((selectData[0].orderState !== 0 || !selectData[0].num) && selectData[0].stowageType != 2) {
        this.$alert('此订单不能分段!', '系统提示')
        return
      }
      if (selectData[0].orderSource == 8) { // 货主端
        this.$alert('此订单不能分段!', '系统提示')
        return
      }
      if (selectData[0].orderSource == 9 || selectData[0].orderSource == 11) { // 首钢配载
        this.$alert('此订单不能分段!', '系统提示')
        return
      }
      if (selectData[0].orderQrCodeId) {
        this.$alert('二维码订单不能分段!', '系统提示')
        return
      }
      this.fenduanFlag = true
    },
    // 取消分段
    qxfdFn (row) {
      this.$confirm('是否执行取消分段操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cancelSectionOpenOrde({
          orderBusinessId: row.orderBusinessId,
          orderId: row.orderId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 转包
    zhuanbaoFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].orderState !== 0) {
        this.$alert('此订单不能转包!', '系统提示')
        return
      }
      if (selectData[0].orderSource == 1 || selectData[0].orderSource == 9 || selectData[0].orderSource == 10 || selectData[0].orderSource == 11) {
        this.$alert('此订单不能转包!', '系统提示')
        return
      }
      if (selectData[0].stowageType == 2) { // 分段不能转包
        this.$alert('此订单不能转包!', '系统提示')
        return
      }
      if (selectData[0].orderQrCodeId) {
        this.$alert('二维码订单不能转包!', '系统提示')
        return
      }
      if (!selectData[0].freightAmount && !selectData[0].orderAce) {
        this.$alert('请联系业务人员完善运费信息!', '系统提示')
        return
      }
      this.rowData = selectData[0]
      this.goodform = { subcontractType: 0 }
      this.$set(this.goodform, 'orderWeight', selectData[0].orderWeight)
      this.goodform.orderId = selectData[0].orderId
      this.goodform.orderBusinessId = selectData[0].orderBusinessId
      this.goodform.measuringUnit = selectData[0].measuringUnit
      this.goodform.orderAce = selectData[0].orderAce// 证明是子订单
      // 支出信息回显
      if (selectData[0].freightAmount) {
        this.$set(this.goodform, 'expenditurePattern', selectData[0].expenditurePattern.toString())
        this.$set(this.goodform, 'expenditurePatternName', selectData[0].expenditurePatternName)
        this.$set(this.goodform, 'freightPricingType', selectData[0].freightPricingType.toString())
        this.$set(this.goodform, 'freightPricingTypeName', selectData[0].freightPricingTypeName)
        this.$set(this.goodform, 'freightUnitPrice', selectData[0].freightUnitPrice)
        this.$set(this.goodform, 'freightAmount', selectData[0].freightAmount)
        this.goodform.oldJin = selectData[0].freightAmount
      }
      getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })

      getCurrUserCompany().then(res => { this.zigsList = res })
      this.ZBflag = true
    },
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      }
    },
    ZBsaveFn () {
      if (this.goodform.freightAmount > this.goodform.oldJin) {
        this.$alert('运费金额不能大于订单原有金额!', '系统提示')
        return
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          subcontract(this.goodform).then(res => {
            loading.close()
            this.ZFflag = false
            this.getList(this.searchFrom)
            this.ZBflag = false
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 转包选择承运商
    // generalCarrierChange (e) {
    //   console.log(e)
    //   let json = this.CYSList.filter(item => item.customerName == e)
    //   this.$set(this.goodform, 'generalTaxId', json[0].customerTaxId)
    //   this.$set(this.goodform, 'generalCode', json[0].tenantCode)
    //   // this.$set(this.goodform, 'limitUserId', null)
    //   // this.$set(this.goodform, 'limitUserName', null)
    //   this.$set(this.goodform, 'limitOrgName', null)
    //   this.$set(this.goodform, 'limitOrgCode', null)
    //   this.$set(this.goodform, 'limitSubCompanyName', null)
    //   this.$set(this.goodform, 'limitSubCompanyCode', null)
    //   let tenantCode = json[0].tenantCode
    //   if (!tenantCode) {
    //     this.$alert('此承运商没有开通账号，不能转包!', '系统提示')
    //     this.$set(this.goodform, 'generalCarrier', null)
    //   }
    // },
    handleChange (e) {
      console.log(e)
    },
    // 选择部门
    bumenChange (e) {
      let orgSubCode = localStorage.getItem('orgSubCode')
      if (e == orgSubCode) {
        this.$alert('不能转包给本部门!', '系统提示')
        return
      }
      let json1 = this.bumenList.filter(item => item.code == e)
      this.$set(this.goodform, 'limitSubOrgName', json1[0].name)
      this.$set(this.goodform, 'generalTaxId', '')
      this.$set(this.goodform, 'generalCode', '')
      this.$set(this.goodform, 'limitUserId', null)
      this.$set(this.goodform, 'limitUserName', null)
      getDepartmentUsers({ subOrgCode: e }).then(res => { this.yonghuList = res })
    },
    bumenChangeCX (e) {
      let json1 = this.bumenList.filter(item => item.name == e)
      getDepartmentUsers({ subOrgCode: json1[0].code }).then(res => { this.yonghuList = res })
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'limitUserName', json[0].userName)
      this.$set(this.goodform, 'limitOrgName', json[0].orgName)
      this.$set(this.goodform, 'limitOrgCode', json[0].orgCode)
      this.$set(this.goodform, 'limitSubCompanyName', json[0].subCompanyName)
      this.$set(this.goodform, 'limitSubCompanyCode', json[0].subCompanyCode)
      this.$set(this.goodform, 'limitUserPhone', json[0].mobile)
      this.$set(this.goodform, 'generalCarrier', null)
      this.$set(this.goodform, 'generalTaxId', null)
      this.$set(this.goodform, 'generalCode', null)
    },
    // 转包类型修改
    zbChange (e) {
      if (e == 2) {
        this.$set(this.goodform, 'limitUserId', null)
        this.$set(this.goodform, 'limitUserName', null)
        this.$set(this.goodform, 'limitOrgName', null)
        this.$set(this.goodform, 'limitOrgCode', null)
        this.$set(this.goodform, 'limitSubOrgCode', null)
        this.$set(this.goodform, 'limitSubOrgName', null)
        this.$set(this.goodform, 'limitSubOrgId', null)
        this.$set(this.goodform, 'limitSubCompanyName', null)
        this.$set(this.goodform, 'limitSubCompanyCode', null)
        this.$set(this.goodform, 'limitUserPhone', null)
      } else {
        this.$set(this.goodform, 'gsUserName', null)
        this.$set(this.goodform, 'gsUserId', null)
        this.$set(this.goodform, 'gsSubOrgCode', null)
        this.$set(this.goodform, 'gsSubOrgName', null)
        this.$set(this.goodform, 'gsOrgName', null)
        this.$set(this.goodform, 'gsOrgCode', null)
        this.$set(this.goodform, 'gsSubCompanyName', null)
        this.$set(this.goodform, 'gsSubCompanyCode', null)
        this.$set(this.goodform, 'gsSubCompanyTaxId', null)
        this.$set(this.goodform, 'generalCarrier', null)
        this.$set(this.goodform, 'generalTaxId', null)
        this.$set(this.goodform, 'generalCode', null)
      }
    },
    // 选择分子公司
    fzgsChange (e) {
      let companyCode = localStorage.getItem('companyCode')
      if (e == companyCode) {
        this.$alert('不能转包给本公司!', '系统提示')
        return
      }
      let json = this.zigsList.filter(item => item.companyCode == e)
      this.$set(this.goodform, 'gsSubCompanyTaxId', json[0].taxpayerNumber)
      getCurrUserDepartment({ compayCode: e }).then(res => { this.FZbumenList = res })
      this.$set(this.goodform, 'gsUserName', null)
      this.$set(this.goodform, 'gsUserId', null)
      this.$set(this.goodform, 'gsSubOrgCode', null)
      this.$set(this.goodform, 'gsSubOrgName', null)
      this.$set(this.goodform, 'gsOrgName', null)
      this.$set(this.goodform, 'gsOrgCode', null)
      this.$set(this.goodform, 'generalCarrier', null)
      this.$set(this.goodform, 'generalTaxId', null)
      this.$set(this.goodform, 'generalCode', null)
    },
    // 选择部门
    FZbumenChange (e) {
      getDepartmentUsers({ subOrgCode: e }).then(res => { this.FZyonghuList = res })
    },
    // 选择用户
    FZyonghuChange (e) {
      let json = this.FZyonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'gsUserName', json[0].userName)
      this.$set(this.goodform, 'gsSubOrgCode', json[0].subOrgCode)
      this.$set(this.goodform, 'gsSubOrgName', json[0].subOrgName)
      this.$set(this.goodform, 'gsOrgName', json[0].orgName)
      this.$set(this.goodform, 'gsOrgCode', json[0].orgCode)
      this.$set(this.goodform, 'gsSubCompanyCode', json[0].subCompanyCode)
      this.$set(this.goodform, 'gsSubCompanyName', json[0].subCompanyName)
    },
    // 取消转包
    QXzhuanbaoFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].stowageType != 1) {
        this.$alert('此订单不能取消转包!', '系统提示')
        return
      }
      this.$confirm('是否执行取消转包操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelSubcontract({ orderBusinessId: selectData[0].orderBusinessId }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '取消成功',
            type: 'success'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(() => {

      })
    },
    // 拆单合单
    chaihedanFN (n) {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let isyouhuo = selectData[0].goodsYn
      let danwei = selectData[0].measuringUnit
      let businessUnit = selectData[0].businessUnit
      this.rowDataList = selectData
      this.rowDataList.forEach(item => {
        item.goodList = []
      })
      let flag4 = selectData.some(item => item.stowageType == 2)
      if (flag4) {
        this.$alert('已分段的订单不能进行操作', '系统提示')
        return
      }
      if (n == 1) { // 合单
        if (selectData.length < 2) {
          this.$alert('请选择两条以上的数据进行操作', '系统提示')
        } else {
          let flag1 = selectData.every(item => item.goodsYn == isyouhuo)
          let flag2 = selectData.every(item => item.measuringUnit == danwei)
          let flag3 = selectData.some(item => item.orderState == 2)
          let flag4 = selectData.some(item => item.orderSource == 9 || item.orderSource == 10 || item.orderSource == 11)
          let flag5 = selectData.every(item => item.businessUnit == businessUnit)
          let flag6 = selectData.some(item => item.revenueValuation == 1)
          let flag7 = selectData.some(item => item.orderQrCodeId)
          let flag8 = selectData.some(item => item.handleState != 3 && item.handleState != 5)
          // if (flag8) {
          //   this.$alert('请先承运再进行合单操作', '系统提示')
          //   return
          // }
          if (!flag1) {
            this.$alert('只有都是有货或者无货的订单才能合单', '系统提示')
            return
          }
          if (!flag2) {
            this.$alert('只有货物单位相同的订单才能合单', '系统提示')
            return
          }
          if (!flag5) {
            this.$alert('只有同业务部门才能合单', '系统提示')
            return
          }
          if (flag3) {
            this.$alert('已处理的订单不能合单', '系统提示')
            return
          }
          if (flag4) {
            this.$alert('首钢配载订单不能进行合单', '系统提示')
            return
          }
          if (flag6) {
            this.$alert('包干的订单不允许合单', '系统提示')
            return
          }
          if (flag7) {
            this.$alert('二维码订单不允许合单', '系统提示')
            return
          }
          this.rowDataList[0].splittOrder = null
          if (isyouhuo == 1) {
            this.ZPYHflag = true
          } else {
            this.ZPWHflag = true
          }
        }
      } else {
        if (selectData.length != 1) {
          this.$alert('请选择一条要操作的数据', '系统提示')
        } else {
          // if (selectData[0].handleState != 3 && selectData[0].handleState != 5) {
          //   this.$alert('请先承运再进行拆单操作', '系统提示')
          //   return
          // }
          if (selectData[0].orderSource == 9 || selectData[0].orderSource == 10 || selectData[0].orderSource == 11) {
            this.$alert('首钢配载订单不能拆单', '系统提示')
            return
          }
          if (selectData[0].orderState == 2) {
            this.$alert('已处理的订单不能拆单', '系统提示')
            return
          }
          if (isyouhuo == 1) {
            this.ZPYHflag = true
            this.rowDataList[0].splittOrder = null
          } else {
            this.ZPWHflag = true
            this.rowDataList[0].splittOrder = 1
          }
        }
      }
    },
    // 指派
    zhipaiFN () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      // if (selectData[0].handleState != 3 && selectData[0].handleState != 5) {
      //   this.$alert('请先承运再进行指派操作', '系统提示')
      //   return
      // }
      if (selectData[0].orderState == 2) {
        this.$alert('已处理的订单不能指派', '系统提示')
        return
      }
      if (selectData[0].stowageType == 2) {
        this.$alert('已分段的订单不能进行指派', '系统提示')
        return
      }
      if (selectData[0].orderSource == 9 || selectData[0].orderSource == 10 || selectData[0].orderSource == 11) {
        this.$alert('首钢配载订单不能进行指派', '系统提示')
        return
      }
      this.ZPflag = true
    },
    // 新建
    addFn (flag, row) {
      if (flag == 2) { // 复制  关联货物flag 1 为显示，2为隐藏
        if (row.transportMode == 1) { // 汽运
          this.$router.push({ name: 'qiYunOrderAdd', query: { id: row.orderBusinessId, flag: this.btnFlg[18] ? 1 : 2 } })
        } else {
          this.$router.push({ name: 'qiYunOrderAddEditHY', query: { id: row.orderBusinessId, flag: this.btnFlg[18] ? 1 : 2 } })
        }
      } else {
        this.$router.push({ name: 'qiYunOrderAdd', query: { flag: this.btnFlg[18] ? 1 : 2 } })
      }
    },
    addHYFn () {
      this.$router.push({ name: 'qiYunOrderAddEditHY' })
    },
    // 修改
    editFN (row) {
      checkUpdateOrder({ orderBusinessId: row.orderBusinessId }).then(res => {
        if (row.transportMode == 1) { // 汽运
          this.$router.push({ name: 'qiYunOrderEdit', query: { id: row.orderBusinessId, flag: this.btnFlg[18] ? 1 : 2 } })
        } else {
          this.$router.push({ name: 'qiYunOrderAddEditHY', query: { id: row.orderBusinessId, isEdit: 1 } })
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 分段修改
    editFN1 (row) {
      if (row.orderState === 0) { // 待处理直接调修改页面
        this.$router.push({ name: 'qiYunOrderEdit', query: { id: row.orderBusinessId, flag: this.btnFlg[18] ? 1 : 2 } })
      } else {
        this.rowData = row
        findSonSectionList({ orderId: row.orderId, orderBusinessId: row.orderBusinessId }).then((res) => {
          this.zidanList = [
            { orderId: res[0].orderId, orderState: res[0].orderState },
            { orderId: res[res.length - 1].orderId, orderState: res[res.length - 1].orderState }
          ]
          this.xiugaiDizhiFlag = true
        })
      }
    },
    // 首钢修改
    editFN2 (row) {
      this.rowData = row
      this.xiugaiSGFlag = true
    },
    exportList (val) {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.arrivalTimes) {
        this.searchFrom.arrivalTimeStart = this.searchFrom.arrivalTimes[0]
        this.searchFrom.arrivalTimeEnd = this.searchFrom.arrivalTimes[1]
      } else {
        this.searchFrom.arrivalTimeStart = ''
        this.searchFrom.arrivalTimeEnd = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/order/exportOrderList',
        form,
        '订单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },

    // 运单
    wayFn (row) {
      this.$router.push({ name: 'qiYunWay', query: { orderNo: row.orderNo } })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$router.push({ name: 'tmsOrderDayin', query: { id: selectData[0].orderBusinessId } })
      }
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'qiYunOrderDetails', query: { id: row.orderBusinessId } })
    },
    // 详情-天津中物
    TJdetailFn (row) {
      this.$router.push({ name: 'qiYunOrderDetailsTJ', query: { id: row.orderBusinessId } })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.arrivalTimes) {
        this.searchFrom.arrivalTimeStart = this.searchFrom.arrivalTimes[0]
        this.searchFrom.arrivalTimeEnd = this.searchFrom.arrivalTimes[1]
      } else {
        this.searchFrom.arrivalTimeStart = ''
        this.searchFrom.arrivalTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.selectedRows = selection
      this.weight = 0
      var that = this
      selection.forEach((item) => {
        // that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.orderState != 3) {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    // 获取货物列表
    getList (searchFrom) {
      findOrderList(searchFrom).then((res) => {
        this.symbolKey = Symbol(new Date().toString())
        this.tableList = []
        res.list.forEach(item => {
          if (item.stowageType == 2) {
            item.children = []
            item.hasChildren = true
          }
          this.tableList.push(item)
        })
        this.total = res.total
      })
    },
    load (tree, treeNode, resolve) {
      findSonSectionList({ orderId: tree.orderId, orderBusinessId: tree.orderBusinessId }).then((res) => {
        resolve(res)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在处理...'
      // })
      // impOrder(formData).then(res => {
      //   loading.close()
      //   this.importDialog = false
      //   var that = this
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: res,
      //     duration: 0,
      //     type: 'success',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      //   that.getList(that.searchFrom)
      // }).catch(error => {
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: error.message,
      //     duration: 0,
      //     type: 'error',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      // })
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待审核'
        case 1004:
          return '已通过'
        case 1101:
          return '议价中'
        case 1201:
          return '待承运'
        case 1202:
          return '承运中'
        case 1203:
          return '已送达'
        case 1301:
          return '已签收'
        default:
          return '已结算'
      }
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, this.goodform.freightUnitPrice), 2))
        }
        if (this.goodform.freightAmount && this.goodform.serviceRate) {
          let n = this.goodform.serviceRate / 100
          this.$set(this.goodform, 'serviceCharge', toFixed(accMul(this.goodform.freightAmount, n), 2))
        } else {
          this.$set(this.goodform, 'serviceCharge', 0)
        }
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  },
  activated () {
    if (!this.$route.meta.isBack) { // 清空查询条件
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        orderStates: '0,1'
      }
      if (this.$route.params) {
        this.$set(this.searchFrom, 'orderNo', this.$route.params.orderNo)
      }
      this.getList(this.searchFrom)
    } else {
      if (this.$route.params) {
        this.$set(this.searchFrom, 'orderNo', this.$route.params.orderNo)
      }
      this.$route.meta.isBack = false
      this.getList(this.searchFrom)
    }
    this.ZPflag = false
    this.ZPWHflag = false
    this.ZPYHflag = false
  },
  // inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    // to.meta.keepAlive = true
    // if (from.path !== '/qiYunOrder/add' && from.path != '/qiYunOrder/edit' && from.path != '/qiYunOrder/details') {
    //   next(vm => {
    //     // vm.reload()
    //   })
    // } else {
    //   next()
    // }
    if (from.path == '/qiYunOrder/add' || from.path == '/qiYunOrder/edit' || from.path == '/qiYunOrder/details') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
  // beforeRouteLeave (to, from, next) {
  //   if (to.path == '/qiYunOrder/add' || to.path == '/qiYunOrder/edit' || to.path == '/qiYunOrder/details') {
  //     from.meta.keepAlive = true
  //   } else {
  //     from.meta.keepAlive = false
  //   }
  //   next()
  // }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}

/deep/.el-form{
  width: 100%;
}
.box1 span {
  margin-left: 10px;
  font-size: 12px;
}
.addressBox .title{
  margin-left: 0;
}
.addressBox{
  margin-top:16px;
  margin-bottom: -15px;
}
.red{
color:#F56C6C ;
}
.green{
color:#01884d ;
}

.box3{
  display: flex;
  flex-wrap:wrap;
  .box31{
    min-width: 300px;
  }
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
.box1{
  text-align: right;
  padding-right: 60px;
  /deep/ .icon{
    font-size: 24px;
    color:#0c46a2 ;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.dayinBox{
  padding: 10px;
}
.sytable {
  border-collapse: collapse;
}
.sytable,
.sytable th,
.sytable td {
  border: 1px solid #666;
}
.sytable {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.sel-row{
  background:#b0d0f3  !important;
}
</style>
